import { BASE_URL } from "./config";

export const endpoints = {
  getPlexoUrl: `${BASE_URL}/payments/confirm`,
  getIssuers: `${BASE_URL}/issuers`,
  getPurchaseData: `${BASE_URL}/payments`,
  generatePaymentLink: `${BASE_URL}/api/payment_qr`
};
